import { render, staticRenderFns } from "./ProfileGallery.vue?vue&type=template&id=355f9520&scoped=true&"
import script from "./ProfileGallery.vue?vue&type=script&lang=js&"
export * from "./ProfileGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProfileGallery.vue?vue&type=style&index=0&id=355f9520&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355f9520",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Preloader: require('/home/bitrix/frontend/components/other/Preloader.vue').default,SidebarAnchors: require('/home/bitrix/frontend/components/other/SidebarAnchors.vue').default,List: require('/home/bitrix/frontend/components/gallery/personal/List.vue').default,Mir: require('/home/bitrix/frontend/components/gallery/personal/Mir.vue').default})
